/* eslint-disable camelcase */

import Reqwest from 'reqwest'
import Bean from 'bean'
import Cookies from 'js-cookie'
import Qwery from 'qwery'

import { unsupportedProductTracking } from './tracking'
import { debug, subscribe, getLanguage, removeElementsByClassName } from './utilities'
import { selectOptionInSelect } from './dom-utilities'
import { smartSizeSelection, smartSizeSelectionVP } from './select-size'
import { createSizeInsights } from './size-insights'

let emitter = require('./event-emitter').eventHandler()
export { emitter }

let male_list = ['man', 'm', 'men', 'boy', 'boys', 'him', 'male', 'homme', 'mens']
let female_list = ['woman', 'women', 'f', 'girl', 'girls', 'her', 'female', 'femme', 'womens', 'dame', 'kvinde']

export function findGender (gender) {
  if (gender) {
    return (male_list.indexOf(gender.toLowerCase()) !== -1) ? 'male' : (female_list.indexOf(gender.toLowerCase()) !== -1) ? 'female' : gender
  } else {
    return gender
  }
}

export function enableEasySizeFeatures (params) {
  if (!params.easysize.dom_updates) {
    debug('Easysize turned off enableEasySizeFeatures')
    window.dispatchEvent(new CustomEvent('easysize_loaded', { detail: { supported: true } }))
    if (params.easysize.loaded) {
      params.easysize.loaded({
        is_product_supported: true
      }, false)
    }
    return
  }

  loadEasySizeButton(params)
  if (params.features.size_advice_qa) {
    Bean.on(document, 'click', '.easysize_button', () => {
      require.ensure('./size-advisor-qa', (require) => {
        require('./size-advisor-qa').startQaAdvisor(params)
      })
    })

    Bean.on(document, 'click', '.easysize-widget', () => {
      require.ensure('./size-advisor-qa', (require) => {
        require('./size-advisor-qa').startQaAdvisor(params)
      })
    })

    // Bean.on(document, 'click', '.easysize_button__returning', () => {
    //   require.ensure('./size-advisor-qa', (require) => {
    //     require('./size-advisor-qa').startQaAdvisor(params, 'returning')
    //   })
    // })

    // Bean.on(document, 'click', '.easysize_button__out_of_stock', () => {
    //   require.ensure('./size-advisor-qa', (require) => {
    //     require('./size-advisor-qa').startQaAdvisor(params, 'out-of-stock-no-recommendation')
    //   })
    // })

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        if (e.target.matches('.easysize_button') || e.target.matches('.easysize_button')) {
          require('./size-advisor-qa').startQaAdvisor(params)
        }
        if (e.target.matches('.easysize_button__returning') || e.target.matches('.easysize_button__out_of_stock') || e.target.matches('.es-recommended')) {
          require('./size-advisor-qa').startQaAdvisor(params, 'returning')
        }
      }

    })

  }
}

export function elementVisible(selector) {
  // We element exists and is visible, return true
  // If selector is stirng, assume it's selector, otherwise see it as element
  let element = typeof(selector) === 'string' ? document.querySelector(selector) : selector
  if (element) {
    if (element.checkVisibility) {
      return element.checkVisibility()
    } else {
      return true
    }
  }
  return false
}

function PredictGloboSwatch() {
  EasySizeParametersDebug.shop.prediction = 'globo-swatch';
  EasySizeParametersDebug.shop.size_dropdown_selector = '.globo-swatch-product-detail';
  EasySizeParametersDebug.shop.easysize_button_placeholder_selector = '.globo-swatch-product-detail';
  EasySizeParametersDebug.shop.update_size_dropdown = function(size) {
      let size_element = document.querySelector('.globo-swatch-product-detail [value="' + size + '"]')
      if (size_element) {
          size_element.click();
          EasySizeParametersDebug.shop.original_size_update_function(size);
          return true;
      }
      return params.shop.original_size_update_function(size);
  }

  if (window.easy_size) {
    setTimeout(window.easy_size.refresh, 100)
  }
}

export function predictPlaceholders (params) {
  let es_placeholder = false;
  window.removeEventListener('Globo.swatch.loaded', PredictGloboSwatch)

  if (params.button.predict) {
    window.addEventListener('Globo.swatch.loaded', PredictGloboSwatch)
    // Predict variant swatch king. 
    if (window.VariantSwatchKing) {
      params.shop.prediction = 'variant-swatch-king';
      params.shop.size_dropdown_selector = 'variant-swatch-king';
      params.shop.easysize_button_placeholder_selector = 'variant-swatch-king';
      es_placeholder = document.querySelector('variant-swatch-king')

      return es_placeholder
    }

    // Predict globbo
    if (!es_placeholder && elementVisible('.globo-swatch-product-detail')) {
      params.shop.prediction = 'globo-swatch';
      params.shop.size_dropdown_selector = '.globo-swatch-product-detail';
      params.shop.easysize_button_placeholder_selector = '.globo-swatch-product-detail';
      es_placeholder = document.querySelector('.globo-swatch-product-detail')

      return es_placeholder
    }

    // Predict variant-selects
    if (!es_placeholder && elementVisible('variant-selects')) {
      params.shop.prediction = 'variant-selects';
      params.shop.size_dropdown_selector = 'variant-selects';
      params.shop.easysize_button_placeholder_selector = 'variant-selects';
      es_placeholder = document.querySelector('variant-selects')

      return es_placeholder
    }
    
    // Predict Groupify / mpg-swatch
    if (!es_placeholder && elementVisible('.mpg-swatch')) {
      params.shop.prediction = 'groupify';
      params.shop.size_dropdown_selector = '.mpg-swatch';
      params.shop.easysize_button_placeholder_selector = '.mpg-swatch';
      es_placeholder = document.querySelector('.mpg-swatch')

      return es_placeholder
    }

    // Predict product-variants
    if (!es_placeholder && elementVisible('product-variants')) {
      params.shop.prediction = 'product-variants';
      params.shop.size_dropdown_selector = 'product-variants';
      params.shop.easysize_button_placeholder_selector = 'product-variants';
      es_placeholder = document.querySelector('product-variants')

      return es_placeholder
    }

    // Predict variant-picker
    if (!es_placeholder && elementVisible('variant-picker')) {
      params.shop.prediction = 'variant-picker';
      params.shop.size_dropdown_selector = 'variant-picker';
      params.shop.easysize_button_placeholder_selector = 'variant-picker';
      es_placeholder = document.querySelector('variant-picker')

      return es_placeholder
    }
  }

  return false
}

let prediction_counter = 0;
export function loadEasySizeButton (params) {
  let btn = document.createElement('div')

  if (!document.getElementById('easysize_button')) {
    // Create easysize button and place it after placeholder
    btn.id = 'easysize_button'
    btn.className = 'easysize_button'
    btn.innerHTML = params.button.primary_text
    btn.tabIndex = 0
    btn.role = 'button'
    // btn.setAttribute('data-first', params.button.primary_text)
    // btn.setAttribute('data-second', params.button.secondary_text)
    // btn.dataset.first = params.button.primary_text;
    // btn.dataset.second = params.button.secondary_text;

    if (params.shop.easysize_button_placeholder_selector.constructor === Array) {
      for (let i = 0; i<params.shop.easysize_button_placeholder_selector.length; i++) {
        let es_placeholder = Qwery(params.shop.easysize_button_placeholder_selector[i])[0]
        if (!es_placeholder) {
          continue
        }

        try {
          es_placeholder[params.elements.button_n_position](btn)
        } catch (e) {
          // Legacy new button add
          debug('[EasySize] Issue adding new user message', e)
          if (es_placeholder && es_placeholder.nextSibling && es_placeholder.nextSibling.id === 'es-recommended') {
            es_placeholder.parentNode.insertBefore(btn, es_placeholder.nextSibling.nextSibling)
          } else {
            es_placeholder.parentNode.insertBefore(btn, es_placeholder.nextSibling)
          }  
        }
      }
    } else {
      // If placeholder not found, we delay the button appearance. We also try to predict additional placeholders
      let es_placeholder = false

      if (Qwery(params.shop.easysize_button_placeholder_selector)[0]) {
        params.shop.prediction = 'original'
        es_placeholder = Qwery(params.shop.easysize_button_placeholder_selector)[0]
      }
      
      // Only predict if it's our predictor es_placeholder
      if (!es_placeholder && params.shop.size_dropdown_selector == '.es_placeholder') {
        es_placeholder = predictPlaceholders(params)
      }
      
      // Fallback to easysize container
      if (!es_placeholder && prediction_counter == 1) {
        params.shop.prediction = '.easysize-container';
        params.shop.size_dropdown_selector = '.easysize-container';
        params.shop.easysize_button_placeholder_selector = '.easysize-container';
        es_placeholder = document.querySelector('.easysize-container')
      }

      if (!es_placeholder) {
        prediction_counter++
        debug(`[EasySize debug]: Placeholder not found, delaying the button appearance`)
        setTimeout(function() {
          loadEasySizeButton(params)
        }, 500);
        return false
      }

      try {
        es_placeholder[params.elements.button_n_position](btn)
      } catch (e) {
        // Legacy new button add
        debug('[EasySize] Issue adding new user message', e)
        if (es_placeholder && es_placeholder.nextSibling && es_placeholder.nextSibling.id === 'es-recommended') {
          es_placeholder.parentNode.insertBefore(btn, es_placeholder.nextSibling.nextSibling)
        } else {
          es_placeholder.parentNode.insertBefore(btn, es_placeholder.nextSibling)
        }
      }
    }

    if (params.experiment.button_html) {
      btn.outerHTML = params.experiment.button_html
    }
  }

  btn = document.getElementById('easysize_button')

  try {
    document.body.classList.add('es-loaded')
  } catch(e) {}
  window.dispatchEvent(new CustomEvent('easysize_loaded', { detail: { supported: true } }))
  if (params.easysize.loaded) {
    params.easysize.loaded({
      is_product_supported: true
    }, false)
  }

  params.elements.easysize_button = btn

  if (!Cookies.get('easysize_button_loaded_for_user')) {
    document.body.classList.add('easysize_new_user_infotip')
    Cookies.set('easysize_button_loaded_for_user', 1, Infinity, '/')
  }
}

export function setLanguage (params, language) {
  // Update language
  params.shop.language = getLanguage(language).language

  let shop = '';
  if (window.Shopify && window.Shopify.shop) {
    shop = window.Shopify.shop;
  }

  // Fetch button texts
  Reqwest({
    method: 'GET',
    url: `${params.easysize.tracking_url}shop/config`,
    data: {
      shop_id: params.shop.generated_shop_id,
      language: params.shop.language,
      shop: shop,
    },
    error: (resp) => { debug(`[EasySize debug]: Error getting easysize styles`) },
    success: (resp) => {
      // resp = JSON.parse(resp)
      if (resp.style && params.easysize.dom_updates) {
        let a = document.createElement('link')
        a.type = 'text/css'
        a.rel = 'stylesheet'
        a.href = 'https://webapp.easysize.me/web_app_v1.0/stylesheets/' + resp.style
        // a.href = "/easysize/library/stylesheets/"+resp.style;
        document.body.appendChild(a)
      } else {
        debug('Easysize turned off loadEasySizeStyle')
      }

      if (resp.placeholder) {
        params.shop.easysize_button_placeholder_selector = resp.placeholder
      }

      params.button.primary_text = params.shop.new_user_text || resp.text.button_text
      params.button.returning_user_text = params.shop.returning_user_text || resp.text.returning_user
      params.button.returning_user_text_out_of_stock = params.shop.returning_user_text || resp.text.returning_user_out_of_stock
      params.button.recommended_size_text = params.shop.returning_user_text || resp.text.size_selected

      // Remove and reload all buttons
      removeElementsByClassName('es-selected')
      removeElementsByClassName('es-recommended')
      removeElementsByClassName('easysize_button')

      if (params.product.brand_id) {
        loadEasySizeButton(params)
        if (params.easysize.calculated_size) {
          emitter.emit('easysize-size-selected')
        }
      }
    }
  })


}

export function loadEasySizeStyle (params) {
  // This is based on product_feedback.languages table
  try {
    let page_language = getLanguage(document.querySelector('html').getAttribute('lang'))
    if (page_language) {
      params.shop.language = page_language.language
    }

    // Monkey patch for Transcy AI translator to correctly pick up the page language
    if (window._transcy && window._transcy.variants && window._transcy.variants.localeCurrent) {
      let transcy_language = window._transcy.variants.localeCurrent
      params.shop.language = getLanguage(transcy_language).language
    }
  } catch (e) {
    debug('Unable to automatically recognise language')
  }

  let shop = '';
  if (window.Shopify && window.Shopify.shop) {
    shop = window.Shopify.shop;
  }

  Reqwest({
    method: 'GET',
    url: `${params.easysize.tracking_url}shop/config`,
    data: {
      shop_id: params.shop.generated_shop_id,
      language: params.shop.language,
      shop: shop,
    },
    error: (resp) => { debug(`[EasySize debug]: Error getting easysize styles`) },
    success: (resp) => {
      // resp = JSON.parse(resp)
      if (resp.style && params.easysize.dom_updates) {
        let a = document.createElement('link')
        a.type = 'text/css'
        a.rel = 'stylesheet'
        a.href = 'https://webapp.easysize.me/web_app_v1.0/stylesheets/' + resp.style
        // a.href = "/easysize/library/stylesheets/"+resp.style;
        document.body.appendChild(a)
      } else {
        debug('Easysize turned off loadEasySizeStyle')
      }

      if (resp.placeholder) {
        params.shop.easysize_button_placeholder_selector = resp.placeholder
      }

      params.elements.extra = {}
      if (resp.hasOwnProperty('elements')) {
        let elements = resp.elements
        for (let element in elements) {
          params.elements.extra[element] = elements[element]
        }
      }

      if (resp.hasOwnProperty('features')) {
        params.features = Object.assign(params.features, resp.features)

        if (params.features.hasOwnProperty('custom_css')) {
          document.head.insertAdjacentHTML('beforeend', '<style>' + params.features.custom_css + '</style>')
        }

        if (params.features.hasOwnProperty('custom_css_advanced')) {
          document.head.insertAdjacentHTML('beforeend', '<style>' + params.features.custom_css_advanced + '</style>')
        }

        if (params.features.hasOwnProperty('shopify_cart_fix')) {
          document.addEventListener('click', function(e) {
            if (!e.target.matches(EasySizeParametersDebug.shop.add_to_cart_btn_selector)) return;
            setTimeout(function() {
              fetch(window.Shopify.routes.root + 'cart.js')
              .then(response => response.json())
              .then(data => {
                let item = data['items'][0];
                if (item) {
                  if (!item.properties) {
                    item.properties = {};
                  }

                  if (!item.properties.hasOwnProperty('_esid')) {
                    let properties = item.properties;
                    properties['_esid'] = EasySizeParametersDebug.easysize.pageview_id;
                    fetch(window.Shopify.routes.root + 'cart/change.js', {
                        method: 'POST',
                        headers: {
                          'Accept': 'application/json',
                          'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                          'id': data['items'][0]['key'],
                          'properties': properties
                        })
                    });
                  }
                }
              })
            }, 1000)
          })
        }

        if (params.features.hasOwnProperty('size_insights_texts')) {
          debug('Easysize exposing size insights')
          window.EasysizeSizeInsights = function(conf) {
            createSizeInsights(conf)
          }
        }
      }

      try {
        if (resp.hasOwnProperty('configuration') && resp.configuration.hasOwnProperty('gender')) {
          let tags = EasySizeParametersDebug.product.tags.map(tag => "[Tag] " + tag);
          let is_male = resp.configuration.gender.male_mapping.filter(t => tags.includes(t)).length
          let is_female = resp.configuration.gender.female_mapping.filter(t => tags.includes(t)).length
          let is_unisex = resp.configuration.gender.unisex_mapping.filter(t => tags.includes(t)).length
          let product_gender = is_male ? "m" : is_female ? "f" : resp.configuration.gender.default_gender || 'u';
          if (is_male && is_female || is_unisex) {
            product_gender = 'u'
          }
          EasySizeParametersDebug.product.gender = product_gender
        }
      } catch(e) {
        console.warn('[Easysize] Error configuring gender', e)
      }

      try {
        if (resp.hasOwnProperty('configuration') && resp.configuration.hasOwnProperty('shop_id')) {
          params.shop.generated_shop_id = resp.configuration.shop_id
        }
      } catch(e) {
        console.warn('[Easysize] Error configuring shop id', e)
      }

      try {
        if (!params.product.brand && resp.hasOwnProperty('configuration') && resp.configuration.hasOwnProperty('brand')) {
          params.product.brand = resp.configuration.brand
        }
      } catch(e) {
        console.warn('[Easysize] Error configuring brand', e)
      }

      try {
        // Shopify product variant to stock recognition
        if (resp.hasOwnProperty('configuration') && resp.configuration.hasOwnProperty('product_options') && resp.configuration.product_options.hasOwnProperty('size') && params.product.variants) {
          let size_option_titles = resp.configuration.product_options.size;
          let fit_option_titles = resp.configuration.product_options.fit;
          let length_option_titles = resp.configuration.product_options.length;
          let product_variants = params.product.variants;
          let product_options = params.product.options;
          let size_option_index = -1;
          let fit_option_index = -1;
          let length_option_index = -1;
          let sizes_in_stock = {};
          let available_fits = [];
          let available_lengths = [];

          for (let i = 0; i < product_options.length; i++) {
            // Find size option
            for (let y = 0; y < size_option_titles.length; y++) {
              if (product_options[i].toLowerCase().trim() === size_option_titles[y].toLowerCase()) {
                size_option_index = "option" + (i+1);
                params.product.size_option_index = size_option_index;
                break;
              }
            }
            // Find fit option
            if (fit_option_titles) {
              for (let y = 0; y < fit_option_titles.length; y++) {
                if (product_options[i].toLowerCase().trim() === fit_option_titles[y].toLowerCase()) {
                  fit_option_index = "option" + (i+1);
                  params.product.fit_option_index = fit_option_index;
                  break;
                }
              }
            }
            // Find length option
            if (length_option_titles) {
              for (let y = 0; y < length_option_titles.length; y++) {
                if (product_options[i].toLowerCase().trim() === length_option_titles[y].toLowerCase()) {
                  length_option_index = "option" + (i+1);
                  params.product.length_option_index = length_option_index;
                  break;
                }
              }
            }
          }
          
          if (size_option_index === -1) {
            let found = false;
            for (let i = 0; i < product_options.length; i++) {
              // If not found, try looking for size option inside isntead of exact match
              for (let y = 0; y < size_option_titles.length; y++) {
                if (product_options[i].toLowerCase().trim().indexOf(size_option_titles[y].toLowerCase()) !== -1) {
                  found = true;
                  size_option_index = "option" + (i+1);
                  break;
                }
              }
          
              if (found) break;
            }
          }
        
          for (let i = 0; i < product_variants.length; i++) {
            let size = product_variants[i][size_option_index];
            let fit = product_variants[i][fit_option_index];
            let length = product_variants[i][length_option_index];
            let stock = product_variants[i].available ? 1 : 0;
        
            if (sizes_in_stock.hasOwnProperty(size)) {
              if (sizes_in_stock[size] < stock) {
                sizes_in_stock[size] = stock;
              }
            } else if (size) {
              sizes_in_stock[size] = stock;
            }

            if (fit && available_fits.indexOf(fit) === -1) {
              available_fits.push(fit)
            }
            if (length && available_lengths.indexOf(length) === -1) {
              available_lengths.push(length)
            }
          }

          if (Object.keys(sizes_in_stock).length > 0) {
            params.product.stock = sizes_in_stock
          }
          if (available_fits.length > 0) {
            params.product.available_fits = available_fits
          }
          if (available_lengths.length > 0) {
            params.product.available_lengths = available_lengths
          }
        }
      } catch(e) {
        console.warn('[Easysize] Error configuring size options', e)
      }
    

      params.button.primary_text = params.shop.new_user_text || resp.text.button_text
      params.button.returning_user_text = params.shop.returning_user_text || resp.text.returning_user
      params.button.returning_user_text_out_of_stock = params.shop.returning_user_text || resp.text.returning_user_out_of_stock
      params.button.recommended_size_text = params.shop.returning_user_text || resp.text.size_selected
      params.button.loaded_from_server = true
      params.easysize.product = params.features.size_advice_qa ? 'size-advisor-qa' : 'size-advisor'
      if (Cookies.get('es_force_qa')) {
        params.easysize.product = 'size-advisor-qa'
        params.features.size_advice_qa = true
      }

      try {
        if (window.location.search.indexOf('es_force_qa') !== -1) {
          Cookies.set('es_force_qa', 1, Infinity, '/')
          params.features.size_advice_qa = true
        }
      } catch(e) {}

      if (params.features.hasOwnProperty('custom_javascript')) {
        try {
          eval(params.features.custom_javascript)
        } catch(e) {
          console.warn('[Easysize] Error running custom_javascript', e)
        }
      }
    }
  })
}

export function updateSize (size, params) {
  let options = Qwery(`${params.shop.size_dropdown_selector} option`).map((el) => {
    return el.innerHTML
  })
  let smart_size = smartSizeSelection(size, options)

  if (smart_size) {
    return selectOptionInSelect(params.shop.size_dropdown_selector, smart_size, params)
  }

  return false
}

export function updateSizeVP (size, params) {
  let options = Qwery(`${params.shop.size_dropdown_selector} option`).map((el) => {
    return el.innerHTML
  })
  let smart_size = smartSizeSelectionVP(size, options)

  if (smart_size) {
    return selectOptionInSelect(params.shop.size_dropdown_selector, smart_size, params)
  }

  return false
}

export function applyExperiments (data, params, callback) {
  if (data.experiment_translation_exist) {
    data.experiment_translation.forEach(function (el) {
      switch (el.name) {
        case 'button_text':
          params.button.primary_text = el.text
          break

        case 'returning_user':
          params.button.returning_user_text = el.text.replace('{n}', params.easysize.calculated_size_proven_by)
          setTimeout(() => {
            Qwery('#es-recommended')[0].innerHTML = params.button.returning_user_text
          }, 0)
          break

        case 'size_selected':
          params.button.recommended_size_text = el.text
          break
      }
    })
  }

  if (data.experiment_exist) {
    if (data.experiment.hasOwnProperty('css')) {
      var link = document.createElement('link')
      link.type = 'text/css'
      link.rel = 'stylesheet'
      link.href = 'https://webapp.easysize.me/web_app_v1.0/experiments/css/' + data.experiment.css
      document.head.appendChild(link)
    }

    if (data.experiment.hasOwnProperty('template')) {
      Reqwest({
        method: 'GET',
        url: `https://webapp.easysize.me/web_app_v1.0/experiments/btn/${data.experiment.template}`,
        contentType: 'text/html',
        success: (d) => {
          params.experiment.button_html = d
          callback()
        }
      })
    } else {
      callback()
    }
  } else {
    callback()
  }
}

function handle_cart_click(e) {
  if (e.type != 'easysize-add-to-cart') {
    if (!e.target.matches(EasySizeParametersDebug.shop.add_to_cart_btn_selector) && !e.target.parentNode.matches(EasySizeParametersDebug.shop.add_to_cart_btn_selector)) return;
  }


  try {
    try {
      var selected_size = EasySizeParametersDebug.shop.selected_size
        ? EasySizeParametersDebug.shop.selected_size
        : EasySizeParametersDebug.elements.size_dropdown.options[EasySizeParametersDebug.elements.size_dropdown.selectedIndex].text
    } catch(e) {
      if (EasySizeParametersDebug.features.add_to_cart_value_fallback) {
        var selected_size = eval(EasySizeParametersDebug.features.add_to_cart_value_fallback)
      }

      if (EasySizeParametersDebug.easysize.calculated_size) {
        var selected_size = EasySizeParametersDebug.easysize.calculated_size 
      }
    }

    // Handle custom event, that might contain optional/recommended size parameter
    if (e.type == 'easysize-add-to-cart' && e.detail && e.detail.size) {
      selected_size = e.detail.size
    }

    EasySizeParametersDebug.track(19, selected_size)

    if (EasySizeParametersDebug.features.add_to_cart) {
      require.ensure('./user-wardrobe', (require) => {
        let saveUserItemToWardrobe = require('./user-wardrobe').saveUserItemToWardrobe
        let wardrobeParams = {
          item_gender: EasySizeParametersDebug.product.gender.substr(0, 1),
          item_brand: EasySizeParametersDebug.product.brand_id,
          item_product_type: EasySizeParametersDebug.product.category_id,
          item_size_raw: selected_size,
          source: 'C'
        }

        if (EasySizeParametersDebug.product.fit) {
          wardrobeParams['item_fit'] = EasySizeParametersDebug.product.fit
        }

        if (EasySizeParametersDebug.product.model) {
          wardrobeParams['item_model'] = EasySizeParametersDebug.product.model
        }

        saveUserItemToWardrobe(EasySizeParametersDebug, wardrobeParams)
      })
    }
  } catch (e) {
    console.warn(e)
  }
}

function handle_size_change(e) {
  try {
    let size = e.detail.size
    emitter.emit('easysize_size_selected', size)
    params.shop.selected_size = size
  } catch (e) {
    debug('handle_size_change', e)
  }
}

function handle_set_language(e) {
  try {
    let language = e.detail.language

    setLanguage(EasySizeParametersDebug, language)
  } catch (e) {
    debug('handle_set_language', e)
  }
}

export function checkProduct (params) {
  let form_data = {
    'product_types': JSON.stringify(params.product.category),
    'product_gender': params.product.gender,
    'product_brand': params.product.brand,
    'product_id': params.product.id,
    'qa_support': params.features.hasOwnProperty('size_advice_qa') ? params.features.size_advice_qa : false,
    'sizes_in_stock': JSON.stringify(params.product.stock)
  }

  if (params.product.fit) { form_data.product_fit = params.product.fit }
  if (params.product.model) { form_data.product_model = params.product.model }
  if (params.product.sku) { form_data.product_sku = params.product.sku }

  Reqwest({
    url: `${params.easysize.api_url}${params.shop.generated_shop_id}/check_product/`,
    method: 'GET',
    data: form_data,
    error: (resp) => {
      debug(`[EasySize debug]: Error checking product`)
    },
    success: (resp) => {
      if (resp.status_code) {
        if (resp.error) {
          debug(`[EasySize debug]: EasySize check product failed with [${resp.status_code}] ${resp.error}`)
          unsupportedProductTracking(params)
          window.dispatchEvent(new CustomEvent('easysize_loaded', { detail: { supported: false } }))
          if (params.easysize.loaded) {
            params.easysize.loaded({
              is_product_supported: false
            }, {
              'error': resp.error,
              'status_code': resp.status_code
            })
          }
        } else {
          debug(`[EasySize debug]: EasySize check product failed with [${resp.status_code}]`)
          for (let err in resp) {
            if (err !== 'status_code') {
              debug(`[EasySize debug] Attribute "${err}" - ${resp[err]}`)
            }
          }

          unsupportedProductTracking(params)
          window.dispatchEvent(new CustomEvent('easysize_loaded', { detail: { supported: false } }))
          if (params.easysize.loaded) {
            params.easysize.loaded({
              is_product_supported: false
            }, {
              'status_code': resp.status_code
            })
          }
        }
      } else {
        params.product.brand_id = resp.product_brand_id
        params.product.category = resp.product_types[0].product_type
        params.product.subcategory = resp.product_types[0].subcategory
        params.product.category_id = resp.product_types[0].id
        params.product.category_title = resp.product_types[0].title
        params.product.category_article = resp.product_types[0].article
        params.product.category_collective_noun = resp.product_types[0].collective_noun
        params.product.category_gender = resp.product_types[0].word_gender
        params.product.gender = resp.product_gender
        params.product.fit_id = resp.product_fit_id ? resp.product_fit_id : -1
        params.product.fit = resp.product_fit ? resp.product_fit : params.product.fit
        params.product.model = resp.product_model ? resp.product_model : params.product.model
        params.product.model_settings = resp.product_model_settings || []
        params.shop.language = params.shop.language ? params.shop.language : resp.language
        params.shop.language = params.shop.language.toLowerCase()
        params.product.supported = true
        params.easysize.is_loaded = true

        var parent_group = ''

        if (params.product.category_id === 1) { parent_group = 'tops' }
        if (params.product.category_id === 2) { parent_group = 'bottoms' }
        if (params.product.category_id === 3) { parent_group = 'bottoms' }
        if (params.product.category_id === 4) { parent_group = 'bottoms' }
        if (params.product.category_id === 5) { parent_group = 'tops' }
        if (params.product.category_id === 6) { parent_group = 'tops' }
        if (params.product.category_id === 7) { parent_group = 'tops' }
        if (params.product.category_id === 8) { parent_group = 'tops' }
        if (params.product.category_id === 9) { parent_group = 'bottoms' }
        if (params.product.category_id === 10) { parent_group = 'bottoms' }
        if (params.product.category_id === 11) { parent_group = 'bottoms' }
        if (params.product.category_id === 12) { parent_group = 'bottoms' }
        if (params.product.category_id === 13) { parent_group = 'tops' }
        if (params.product.category_id === 14) { parent_group = 'tops' }
        if (params.product.category_id === 15) { parent_group = 'tops' }
        if (params.product.category_id === 16) { parent_group = 'tops' }
        if (params.product.category_id === 17) { parent_group = 'ethnic' }
        if (params.product.category_id === 18) { parent_group = 'ethnic' }
        if (params.product.category_id === 19) { parent_group = 'ethnic' }
        if (params.product.category_id === 20) { parent_group = 'ethnic' }
        if (params.product.category_id === 21) { parent_group = 'footwear' }
        if (params.product.category_id === 22) { parent_group = 'tops' }
        if (params.product.category_id === 23) { parent_group = 'bottoms' }
        if (params.product.category_id === 24) { parent_group = 'swimwear' }
        if (params.product.category_id === 25) { parent_group = 'tops' }
        if (params.product.category_id === 26) { parent_group = 'tops' }
        if (params.product.category_id === 27) { parent_group = 'bottoms' }
        if (params.product.category_id === 28) { parent_group = 'sets' }

        document.body.classList.add('easysize_group_' + parent_group)
        try {
          if (params.product.subcategory) {
            document.body.classList.add('easysize_subgroup_' + params.product.subcategory.toLowerCase().replace(' ', '').replace('&', ''))
          }
        } catch(e) {}

        emitter.emit('easysize_product_validated')

        // Size insights trigger
        if (params.features.size_insights && resp.product_model_settings) {
          let si_gender = params.product.gender === 'u' ? Object.keys(resp.product_model_settings)[0] : params.product.gender
          let settings = Object.assign(
            resp.product_model_settings[si_gender],
            {
              texts: EasySizeParametersDebug.features.size_insights_texts
            }
          )

          if (Array.isArray(params.features.size_insights)) {
            // Array config
            params.features.size_insights.forEach((conf) => {
              createSizeInsights(Object.assign(settings, conf))
            })
          } else {
            // Single config
            createSizeInsights(Object.assign(settings, params.features.size_insights))
          }
        }
      }
    }
  })

  // params.elements.add_to_cart_button = Qwery(params.shop.add_to_cart_btn_selector)[0];
  if (window.location.href.indexOf('justfemale') !== -1 || window.location.href.indexOf('secondfemale') !== -1) {
    params.elements.add_to_cart_button = Qwery('.add-to-cart ' + params.shop.add_to_cart_btn_selector)[0]
  } else {
    params.elements.add_to_cart_button = Qwery(params.shop.add_to_cart_btn_selector)[0]
  }
  params.elements.button_placeholder = Qwery(params.shop.easysize_button_placeholder_selector)[0]
  params.elements.size_dropdown = Qwery(params.shop.size_dropdown_selector)[0]

  try { document.removeEventListener('click', handle_cart_click) } catch(e) { debug(e) }
  try { window.removeEventListener('easysize-add-to-cart', handle_cart_click) } catch(e) { debug(e) }
  try { window.removeEventListener('easysize-size-change', handle_size_change) } catch(e) { debug(e) }
  try { window.removeEventListener('easysize-set-language', handle_set_language) } catch(e) { debug(e) }

  document.addEventListener('click', handle_cart_click)
  window.addEventListener('easysize-add-to-cart', handle_cart_click)
  window.addEventListener('easysize-size-change', handle_size_change)
  window.addEventListener('easysize-set-language', handle_set_language)

  subscribe('easysize_size_selected', function (size) {
    debug('Size changed to', size)
    params.shop.selected_size = size
    params.track(28, size)
  })

  Bean.on(document, 'change', params.shop.size_dropdown_selector, () => {
    try {
      var selected_size = params.elements.size_dropdown.options[params.elements.size_dropdown.selectedIndex].text
      emitter.emit('easysize_size_selected', selected_size)
    } catch (e) { debug(e) }
  })
}

export function bindEasysizeMessages (params) {
  Bean.on(window, 'message', (message) => {
    debug('[EasySize]: window message received', message)
    if (params.easysize.widget_url.indexOf(message.origin) === 0 || params.easysize.qa_widget_url.indexOf(message.origin) === 0) {
      let data = {}
      try {
        data = JSON.parse(message.data)
      } catch (e) {
        debug('[EasySize]: window message parsing failed', e)
      }

      /*
                SIZE ADVISOR MESSAGES
             */

      // Close easysize size advisor
      if (data.hasOwnProperty('close')) {
        if (params.features.size_advice_qa) {
          require.ensure('./size-advisor-qa', (require) => {
            require('./size-advisor-qa').closeQaAdvisor(params)
          })
        } else {
          require.ensure('./size-advisor', (require) => {
            require('./size-advisor').closeSizeAdvisor(params)
          })
        }

        params.shop.custom_css = params.shop.initial_custom_css
      }

      // Size was not found, remove any returning user text
      if (data.hasOwnProperty('removeReturningUserText')) {
        debug('[EasySize]: removing returning user texts:')
        let es_recommended = Qwery('.es-recommended')[0]
        let es_selected = Qwery('.es-selected')[0]
        document.body.classList.remove('es-selected-size')
        document.body.classList.remove('es-recommended-size')
        if (es_recommended) { es_recommended.parentNode.removeChild(es_recommended) }
        if (es_selected) { es_selected.parentNode.removeChild(es_selected) }
      }

      // Add user item to wardrobe
      if (data.hasOwnProperty('haveBrand') && data.hasOwnProperty('haveItem') && data.hasOwnProperty('haveSize')) {
        require.ensure('./user-wardrobe', (require) => {
          let saveUserItemToWardrobe = require('./user-wardrobe').saveUserItemToWardrobe
          let wardrobeParams = {
            item_gender: params.product.gender.substr(0, 1),
            item_brand: data.haveBrand,
            item_product_type: data.haveItem,
            item_size: data.haveSize,
            source: 'L'
          }

          if (data.hasOwnProperty('haveModel')) {
            wardrobeParams['item_model'] = data.haveModel
          }

          if (data.hasOwnProperty('haveFit')) {
            wardrobeParams['item_fit'] = data.haveFit
          }

          saveUserItemToWardrobe(params, wardrobeParams)
        })
      }

      // Dynamically update size dropdown
      if (data.hasOwnProperty('size') || data.hasOwnProperty('sizeAcc')) {
        if (data.hasOwnProperty('recommendedFit')) {
          params.easysize.recommended_fit = data['recommendedFit']
        }

        if (data.hasOwnProperty('size')) {
          require.ensure('./size-advisor', (require) => {
            require('./size-advisor').closeSizeAdvisor(params)
          })
        }

        let size = data.hasOwnProperty('size') ? data.size : data.sizeAcc
        debug('[EasySize debug]: Trying to update size dropdown with size', size)
        window.postMessage(JSON.stringify({
          'easysize_tracking': true,
          'action': 7,
          'value': size
        }), '*')
        params.easysize.calculated_size = size
        params.easysize.original_calculated_size = data.original_calculated_size
        if (params.product.stock.hasOwnProperty(params.easysize.calculated_size) && params.product.stock[params.easysize.calculated_size] === 0) {
          window.postMessage(JSON.stringify({
            'easysize_tracking': true,
            'action': 21
          }), '*')
          require.ensure(['./size-advisor', './size-advisor-qa'], (require) => {
            let addSizeRecommendedText = require(`./${params.easysize.product}`).addSizeRecommendedText
            addSizeRecommendedText('es-recommended', 'returning_user_text_out_of_stock', 'es-recommended-size', params)
          })
        }

        if (params.shop.update_size_dropdown(size, params)) {
          emitter.emit('easysize-size-selected')
        }
      }

      if (data.hasOwnProperty('addToCart')) {
        setTimeout(() => {
          /* eslint-disable no-undef */
          params.elements.add_to_cart_button = Qwery(params.shop.add_to_cart_btn_selector)[0]
          debug('[EasySize]: reassigning add to cart button to', params.elements.add_to_cart_button)

          if (typeof (params.shop.add_to_cart) === 'function') {
            params.shop.add_to_cart()
          } else if (typeof EasySizeParametersDebug.elements.add_to_cart_button.click === 'function') {
            EasySizeParametersDebug.elements.add_to_cart_button.click()
          /* eslint-enable no-undef */
          } else {
            Bean.fire(params.elements.add_to_cart_button, 'click')
          }
          window.postMessage(JSON.stringify({
            'easysize_tracking': true,
            'action': 19
          }), '*')

          params.shop.custom_css = params.shop.initial_custom_css
        }, 200)
      }

      if (data.hasOwnProperty('recommended')) {
        let es_recommended_products = Cookies.get('es_recommended_products')

        if (es_recommended_products) {
          es_recommended_products = JSON.parse(es_recommended_products)
        } else {
          es_recommended_products = []
        }

        es_recommended_products.push(data.recommended)
        Cookies.set('es_recommended_products', JSON.stringify(es_recommended_products), Infinity, '/')
        if (window.hasOwnProperty('open')) {
          window.open(data.product_url)
        } else {
          window.location.href = data.product_url
        }
      }

      /*
                SIZE BOT MESSAGES
             */

      if (data.hasOwnProperty('easysize-toggle-size-bot')) {
        // eslint-disable-next-line no-undef
        if (_hasClass('#es-sizebot', 'open')) {
          require.ensure('./size-bot', (require) => {
            let closeSizeBot = require('./size-bot').closeSizeBot
            closeSizeBot()
          })
        } else {
          require.ensure('./size-bot', (require) => {
            let openSizeBot = require('./size-bot').openSizeBot
            openSizeBot()
          })
        }
      }

      if (data.hasOwnProperty('easysize-size-bot-close')) {
        require.ensure('./size-bot', (require) => {
          require('./size-bot').removeSizeBot()
        })
      }

      if (data.hasOwnProperty('easysize-size-bot-loaded')) {
        // openSizeBot();
        // sizeBotElement.style.display = 'block';
      }
    }
  })

  emitter.on('easysize-size-selected', () => {
    params.track(30)
    require.ensure(['./size-advisor', './size-advisor-qa'], (require) => {
      let addSizeRecommendedText = require(`./${params.easysize.product}`).addSizeRecommendedText
      addSizeRecommendedText('es-recommended', 'returning_user_text', 'es-recommended-size', params)
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/components/features.js